export default __webpack_public_path__ + "static/media/h.81194f7c.svg";